import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Upload, FolderOpen, Trash2 } from "lucide-react";

export default function FilesPage() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const load = () => api.get("/files").then(r => setFiles(r.data.files)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", "general");
    try { await api.post("/files", fd); load(); } catch {}
    setUploading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this file?")) return;
    await api.delete(`/files/${id}`);
    load();
  };

  return (
    <div className="p-6 md:p-8 max-w-4xl" data-testid="files-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-medium text-[#1A1B1A]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Files</h1>
          <p className="text-sm text-[#757675]">{files.length} files</p>
        </div>
        <label className="bg-[#205B5A] text-white px-4 py-2.5 rounded-full text-sm font-medium hover:bg-[#174544] transition-colors flex items-center gap-2 cursor-pointer" data-testid="upload-file-btn">
          <Upload className="w-4 h-4" /> {uploading ? "Uploading..." : "Upload file"}
          <input type="file" className="hidden" onChange={handleUpload} disabled={uploading} />
        </label>
      </div>

      <div className="bg-white rounded-2xl border border-[#1A1B1A]/[0.06] overflow-hidden">
        {files.length === 0 && !loading ? (
          <div className="p-12 text-center">
            <FolderOpen className="w-10 h-10 text-[#757675]/30 mx-auto mb-3" />
            <p className="text-sm text-[#757675]">No files uploaded yet</p>
          </div>
        ) : (
          files.map(f => (
            <div key={f.id} className="flex items-center gap-4 px-5 py-3.5 border-b border-[#1A1B1A]/[0.03] last:border-0 hover:bg-[#FAF9F6] transition-colors">
              <FolderOpen className="w-4 h-4 text-[#205B5A] flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-[#1A1B1A] truncate">{f.filename}</p>
                <p className="text-xs text-[#757675]">{(f.size_bytes / 1024).toFixed(0)} KB · {f.category}</p>
              </div>
              <span className="text-xs text-[#757675] hidden md:block">{f.uploaded_at?.split("T")[0]}</span>
              <button onClick={() => handleDelete(f.id)} className="p-1.5 text-[#757675] hover:text-red-500 transition-colors"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
